import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./nationalDay.css";

const HERO_BG =
  "https://image.bvhvgl.com/images/binzet/websitebenhvien/L%E1%BB%8Bch%20BGD/gemini_generated_image_1jox9u1jox9u1jox.png";

const TIMELINE = [
  {
    time: "19/8/1945",
    title: "Cách mạng Tháng Tám thành công",
    desc: "Nhân dân cả nước đồng loạt vùng lên khởi nghĩa giành chính quyền, đập tan xiềng xích hơn 80 năm đô hộ của thực dân Pháp và phát xít Nhật.",
    icon: "✊",
  },
  {
    time: "14 giờ, ngày 2/9/1945",
    title: "Chủ tịch Hồ Chí Minh đọc Tuyên ngôn Độc lập",
    desc: "Tại Quảng trường Ba Đình lịch sử, Chủ tịch Hồ Chí Minh trịnh trọng tuyên bố với thế giới về sự ra đời của nước Việt Nam Dân chủ Cộng hòa — nhà nước công nông đầu tiên ở Đông Nam Á.",
    icon: "📜",
  },
  {
    time: "1945 – 1975",
    title: "30 năm kháng chiến giữ nước",
    desc: "Dân tộc Việt Nam trải qua hai cuộc kháng chiến trường kỳ chống thực dân Pháp và đế quốc Mỹ, giữ vững nền độc lập, tự do vừa giành được bằng xương máu.",
    icon: "🚩",
  },
  {
    time: "1976 – Nay",
    title: "Đổi mới và phát triển",
    desc: "Đất nước bước vào công cuộc đổi mới toàn diện, hội nhập quốc tế sâu rộng, trở thành một trong những nền kinh tế năng động của khu vực.",
    icon: "🇻🇳",
  },
];

const ACHIEVEMENTS = [
  { num: "81", unit: "Năm", label: "Độc lập dân tộc" },
  { num: "~100", unit: "Triệu", label: "Người dân Việt Nam" },
  { num: "63", unit: "Tỉnh", label: "Thành phố trên cả nước" },
  { num: "6–7%", unit: "/năm", label: "Tăng trưởng GDP bình quân" },
];

export default function NationalDay() {
  const stars = useMemo(
    () =>
      Array.from({ length: 35 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 10,
        duration: 5 + Math.random() * 7,
        size: 8 + Math.random() * 14,
        opacity: 0.5 + Math.random() * 0.5,
      })),
    []
  );

  return (
    <div className="nd-page">
      {/* ===== HERO ===== */}
      <section className="nd-hero">
        <div className="nd-hero__bg" style={{ backgroundImage: `url('${HERO_BG}')` }} />

        {stars.map((s) => (
          <span
            key={s.id}
            className="nd-falling-star"
            style={{
              left: `${s.left}%`,
              animationDelay: `${s.delay}s`,
              animationDuration: `${s.duration}s`,
              fontSize: `${s.size}px`,
              opacity: s.opacity,
            }}
          >
            ★
          </span>
        ))}

        <div className="nd-hero__content">
          <div className="nd-vn-star" />

          <div className="nd-year-badge">
            <span className="nd-year-num">81</span>
            <span className="nd-year-unit">NĂM</span>
          </div>

          <h1 className="nd-title">
            QUỐC KHÁNH NƯỚC CỘNG HÒA
            <br />
            XÃ HỘI CHỦ NGHĨA VIỆT NAM
          </h1>

          <div className="nd-date-banner">
            2 tháng 9 năm 1945 &nbsp;—&nbsp; 2 tháng 9 năm 2026
          </div>

          <p className="nd-subtitle">
            Kỷ niệm 81 năm ngày Chủ tịch Hồ Chí Minh đọc bản Tuyên ngôn Độc
            lập, khai sinh nước Việt Nam Dân chủ Cộng hòa. Tự hào dân tộc
            Việt Nam anh hùng!
          </p>

          <div className="nd-ribbon">
            <div className="nd-ribbon__bar" />
            <span className="nd-ribbon__star">★</span>
            <div className="nd-ribbon__bar" />
          </div>

          <Link to="/" className="nd-back-btn">
            ← Về trang chủ
          </Link>
        </div>
      </section>

      {/* ===== TIMELINE ===== */}
      <section className="nd-section nd-tl-section">
        <div className="nd-container">
          <h2 className="nd-section-title">
            <span className="nd-title-line" />
            Những khoảnh khắc lịch sử
            <span className="nd-title-line" />
          </h2>

          <div className="nd-timeline">
            <div className="nd-tl-axis" />
            {TIMELINE.map((ev, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={i} className="nd-tl-row">
                  {isLeft ? (
                    <>
                      <div className="nd-tl-card nd-tl-card--right">
                        <div className="nd-tl-time">{ev.time}</div>
                        <div className="nd-tl-heading">{ev.title}</div>
                        <div className="nd-tl-desc">{ev.desc}</div>
                      </div>
                      <div className="nd-tl-dot">{ev.icon}</div>
                      <div className="nd-tl-spacer" />
                    </>
                  ) : (
                    <>
                      <div className="nd-tl-spacer" />
                      <div className="nd-tl-dot">{ev.icon}</div>
                      <div className="nd-tl-card nd-tl-card--left">
                        <div className="nd-tl-time">{ev.time}</div>
                        <div className="nd-tl-heading">{ev.title}</div>
                        <div className="nd-tl-desc">{ev.desc}</div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== ACHIEVEMENTS ===== */}
      <section className="nd-section nd-achieve-section">
        <div className="nd-container">
          <h2 className="nd-section-title">
            <span className="nd-title-line" />
            81 năm xây dựng &amp; phát triển
            <span className="nd-title-line" />
          </h2>

          <div className="nd-achieve-grid">
            {ACHIEVEMENTS.map((a, i) => (
              <div key={i} className="nd-achieve-card">
                <div className="nd-achieve-num">{a.num}</div>
                <div className="nd-achieve-unit">{a.unit}</div>
                <div className="nd-achieve-label">{a.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== QUOTE ===== */}
      <section className="nd-section nd-quote-section">
        <div className="nd-container">
          <blockquote className="nd-quote">
            <div className="nd-quote__mark">"</div>
            <p className="nd-quote__text">
              Nước Việt Nam có quyền hưởng tự do và độc lập, và sự thật đã
              thành một nước tự do, độc lập.
            </p>
            <footer className="nd-quote__author">
              — Trích Tuyên ngôn Độc lập, 2/9/1945
            </footer>
          </blockquote>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="nd-footer">
        <div className="nd-vn-star nd-vn-star--sm" />
        <div className="nd-footer-text">
          Hệ thống Y tế Hùng Vương Gia Lai kính chúc toàn thể cán bộ, nhân
          viên và bệnh nhân một ngày lễ <strong>Quốc Khánh 2 tháng 9</strong>{" "}
          ý nghĩa và tự hào!
        </div>
        <div className="nd-vn-star nd-vn-star--sm" />
      </footer>
    </div>
  );
}
